/* eslint-disable max-lines */
import React from 'react';
import CardContent from '@material-ui/core/CardContent';
import Grid from '@material-ui/core/Grid';
import Container from '@material-ui/core/Container';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { IStateList, ListComponent } from 'components/Abstract/List';
import TableWrapper from 'components/Shared/TableWrapper';
import { WithStyles } from 'decorators/withStyles';
import { IDocument } from 'interfaces/document';
import { IEntity } from 'interfaces/entity';
import { IPaginationParams } from 'interfaces/pagination';
import { of } from 'rxjs';
import RxOp from 'rxjs-operators';
import entityService from 'services/entity';
import reportService from 'services/report';

import ListItem from './ListItem';
import { statusesDashboard } from 'interfaces/dashboard';
import TableCell from '@material-ui/core/TableCell';
import Button from '@material-ui/core/Button';
import Hidden from '@material-ui/core/Hidden';

interface IState extends IStateList<any> {
  current?: IDocument;
  formOpened?: boolean;
  entities?: IEntity[];
  reportURL?: string;
}

interface IProps {
  ventureId: number;
  categoryId?: number;
  entityId?: number;
  snapshotId?: string;
  status: statusesDashboard;
  classes?: any;
}

@WithStyles((theme) => ({
  footer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
}))
export default class DashboardStatusDocumentsTable extends ListComponent<
  IProps,
  IState
> {
  timer: NodeJS.Timeout = null;

  constructor(props: IProps) {
    super(props, 'order');
    this.state = {
      ...this.state,
      entities: [] as IEntity[],
    };
  }

  componentDidMount() {
    this.loadData();
  }

  componentWillUnmount() {
    this && this.timer && clearTimeout(this.timer);
  }

  loadData = (params: Partial<IPaginationParams> = {}) => {
    this.setState({ loading: true, error: null });
    const { ventureId, status, snapshotId, entityId, categoryId } = this.props;

    entityService
      .fetchEntitiesGraph(ventureId)
      .pipe(RxOp.logError(), RxOp.bindComponent(this))
      .subscribe(
        (entities) => {
          this.setState({ entities: entities.data });
        },
        (err) => this.setError(err)
      );
    reportService
      .report({
        params: this.mergeParams(params),
        ventureId,
        reportType: 'analytical',
        status,
        onlyLatestFiles: true,
        snapshotId,
        entityId,
        categoryId,
      })
      .pipe(
        RxOp.logError(),
        RxOp.bindComponent(this),
        RxOp.map((items) => this.setPaginatedData(items)),
        RxOp.catchError((error) => of(this.setError(error)))
      )
      .subscribe();
  };

  includes = (item: string, term: string) =>
    item.toLocaleLowerCase().includes(term.toLocaleLowerCase());

  filter = () => {
    const { term } = this.state;
    const metrics = this.state.allItems.map((item) => ({
      ...item,
      filtered: !this.includes(item.name, term),
    }));
    this.setAllItems(metrics);
  };

  handleChangeTerm = (term: string) => {
    if (this.state.loading) return;

    this.setState({ term });
    clearTimeout(this.timeoutTerm);

    if (term && term.length < 3) return;

    this.timeoutTerm = setTimeout(() => this.filter(), 500);
  };

  exportReport = () => {
    this.setState({ loading: true });
    const { ventureId, status, snapshotId, categoryId, entityId } = this.props;
    reportService
      .exportXLS({
        ventureId,
        reportType: 'analytical',
        status,
        snapshotId,
        categoryId,
        entityId,
      })
      .pipe(
        RxOp.logError(),
        RxOp.bindComponent(this),
        RxOp.catchError((err) => of({}))
      )
      .subscribe(
        (data) => {
          if (data.reportURL) window.open(data.reportURL, '_blank');
          this.setState({ loading: false });
        },
        (err) => this.setError(err)
      );
  };

  render() {
    const { items, entities, loading } = this.state;
    const { snapshotId } = this.props;

    return (
      <Container>
        {this.renderLoader()}
        <CardContent>
          <Grid container alignItems="center" justify="flex-end">
            <Grid item xs="auto">
              <Button
                color="primary"
                variant="contained"
                size="large"
                disabled={loading}
                aria-controls="exportar-relatorio"
                aria-haspopup="false"
                onClick={this.exportReport}
              >
                Exportar <Hidden xsDown> relatório</Hidden>
              </Button>
            </Grid>
            <Grid item xs={12}>
              <TableWrapper minWidth={900}>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>Módulo</TableCell>
                      <TableCell align="right">Ordem</TableCell>
                      <TableCell>Aba</TableCell>
                      <TableCell>Subaba</TableCell>
                      <TableCell>Documento</TableCell>
                      <TableCell>Arquivo</TableCell>
                      <TableCell>Emissão</TableCell>
                      <TableCell>Vencimento</TableCell>
                      <TableCell>Tempo de Vencimento</TableCell>
                      <TableCell>Periodicidade</TableCell>
                      <TableCell>Status</TableCell>
                      <TableCell align="center">Situação</TableCell>
                      <TableCell>Upload</TableCell>
                      <TableCell align="right">Validação</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {this.renderEmptyAndErrorMessages(14)}
                    {entities &&
                      entities.length > 0 &&
                      items
                        .filter((file) => !file.filtered)
                        .map((file) => (
                          <ListItem
                            key={file.id || file.documentId}
                            entities={entities}
                            file={file}
                          />
                        ))}
                  </TableBody>
                </Table>
              </TableWrapper>
              {!snapshotId && this.renderTablePagination()}
            </Grid>
          </Grid>
        </CardContent>
      </Container>
    );
  }
}
